// extracted by mini-css-extract-plugin
module.exports = {"root":"itemImage_root__1gEMb"};